module.exports = __webpack_public_path__ + "media/images/icons/levels-e536017928fbb17d26bff68ed57d3eef.svg";